/**
 * One login for the whole panel. Besides its own SSO token, the panel takes the
 * Opengater sign-in: both are issued by the same GlobalAuth, so an operator signed
 * in to Opengater opens Backup, Auth and Tailscale too — no SSO round trip, which
 * only ever returns to the panel's public address.
 */
import { getAccessToken } from './tokens';
import { getOgAccessToken, OG_AUTH_EXPIRED_EVENT } from '@/api/opengater/tokens';
import { refreshOgToken } from '@/api/opengater/refresh';
export function panelBearer() {
    const own = getAccessToken();
    if (own)
        return { token: own, og: false };
    const og = getOgAccessToken();
    return og ? { token: og, og: true } : null;
}
export function hasPanelSession() {
    return panelBearer() !== null;
}
/**
 * Authentication outcomes for a call made with the Opengater token. A 403 is
 * the answer itself — the role can't open this — so the page shows it. A 401 gets one refresh and a retry;
 * if the refresh fails the session is over (its tokens are already cleared) and the
 * gates are told, so the operator lands on the Opengater login.
 */
export async function retryWithFreshOgToken(res, attempt, retry) {
    if (res.status !== 401 || attempt > 0)
        return res;
    if (await refreshOgToken())
        return retry();
    window.dispatchEvent(new CustomEvent(OG_AUTH_EXPIRED_EVENT));
    return res;
}
